import React from "react";
import { Children } from "react";

export const Each = ({ render, of }: { render: any; of: any[] }) => {
  if (!Array.isArray(of)) {
    return null;
  }

  return <>{Children.toArray(of.map((item, index) => render(item, index)))}</>;
};
